module.exports = require("@foundit/clevertap");